import DashboardImage from 'assett/icons/dashboard_image.svg';
import useDevice from 'hooks/DesktopDevice.hook';
import { useLogout } from 'hooks/login.hook';
import { useEffect, useMemo, useState } from 'react';
import { Box } from 'styles';
import Button from 'styles/button/Button';
import ButtonLink from 'styles/button/ButtonLink';
import CardMedia from 'styles/card/CardMedia';
import Stack from 'styles/stack/Stack';
import { useMediaQuery, useTheme } from 'stylesHooks';
import { Dashboard_Go } from 'utils/links';
import { useTranslation } from 'utils/translations';
import { Props } from './DashboardPage.component';
import DashboardMenu from './Menu/DashboardMenu';

export const DashboardPageComponent: React.FC<Props> =
	function DashboardPageComponent(props = {}) {
		const { t: tClientLabels } = useTranslation('', {
			keyPrefix: 'clientLabels',
		});

		const [screenWidth, setScreenWidth] = useState(window.innerWidth);
		const theme = useTheme();
		const { isDesktop } = useDevice();
		const tablet = useMediaQuery(theme.breakpoints.down('lg'));

		const hiddenImage = useMemo(() => {
			if (screenWidth < 1560) {
				return true;
			}
			return false;
		}, [screenWidth]);

		const calculateWidth = () => {
			if (screenWidth < 1560 && screenWidth > 1024) {
				return '80%';
			}
			return '100%';
		};

		const handleLogout = useLogout();

		useEffect(() => {
			const updateDimension = () => {
				setScreenWidth(window.innerWidth);
			};
			window.addEventListener('resize', updateDimension);

			return () => {
				window.removeEventListener('resize', updateDimension);
			};
		}, [screenWidth]);

		return (
			<Stack direction={'column'} gap={'58px'}>
				<Stack direction={'row'} justifyContent={'space-between'} mt={2}>
					<Stack
						width={{
							sm: !hiddenImage ? '60%' : calculateWidth(),
							lg: '60%',
						}}
						justifyContent={'space-between'}
						rowGap={!!isDesktop ? '70px' : '30px'}
						sx={{
							overflow: 'auto',
							overflowX: 'hidden',
						}}
						maxHeight="500px"
					>
						<DashboardMenu />
						<Stack
							direction="row"
							gap={!!tablet ? '18px' : '30px'}
							justifyContent="space-between"
							alignItems="center"
						>
							<Box width="100%">
								<Button variant="contained" onClick={handleLogout}>
									{tClientLabels('dashboard.buttons.logout')}
								</Button>
							</Box>
							<Stack width="100%" direction="row" gap="21px" justifyContent="flex-end">
								{Dashboard_Go(tClientLabels).map(e => (
									<Box key={e.id} flexShrink={0}>
										<ButtonLink startIcon={e.icon} label={e.name} to={e.link} />
									</Box>
								))}
							</Stack>
						</Stack>
					</Stack>
					{!hiddenImage && (
						<Stack
							alignSelf={'flex-end'}
							maxWidth={{ lg: '556px' }}
							maxHeight={{ lg: '430px' }}
							width="30%"
						>
							<CardMedia
								component="img"
								alt={tClientLabels('dashboard.image.alt')}
								image={DashboardImage}
							/>
						</Stack>
					)}
				</Stack>
			</Stack>
		);
	};
